import React from 'react';
import { Modal, Row, Col, Typography } from 'antd';


//Custom
import { CustomBtn } from '../UiElements/UiElements';
//icons
import { AiOutlineWarning ,AiOutlineCheckCircle} from 'react-icons/ai';
import {BiErrorCircle} from 'react-icons/bi';
//styles
import './styles.css'
function ActionDialog({showHide,message,type,onClose,onSubmit}) {

    const handleOk=()=>{

        onSubmit();
        onClose();
    }


    return (
        <Modal
            className="action-dialog-custom-modal"
            centered
            closable={false}
            visible={showHide}
            onCancel={onClose}
            width="35%"
            footer={
                [
                    <div  className="action-dialog-footerButton">
                        
                            { type==="update" ||type==="confirm" ? 
                            <CustomBtn
                            id="save"
                            btnType="primary"
                            htmlType="submit"
                            onClick={handleOk}
                            > Ok
                            </CustomBtn> : ""}
                        <CustomBtn
                            id="reset"
                            type="danger"
                            onClick={onClose}
                        > Cancel
                        </CustomBtn >
                    </div >
                ]
            }
        >
            <Row align="middle">
                 <Col span={24} >{/*style={{display:"flex"}} */}
                    <Col span={24} style={{textAlign:'center'}}>
                        { type==="warning"?
                            <AiOutlineWarning className="warning-icon"/> 
                            :type==="success" ?
                            <AiOutlineCheckCircle className="success-icon"/>
                            :type==="update" ?
                            <BiErrorCircle className="update-icon"/>
                            : type==="confirm" ?
                            <BiErrorCircle className="confirm-icon"/>
                            :''
                        }
                    </Col>
                    <Col span={24} style={{textAlign:'center'}}>
                        <Typography className="dialog-message" >{message} </Typography>
                    </Col>
                </Col>
            </Row>
            </Modal>
    )
}

export default ActionDialog
